'use client'

import { useEffect, useRef, useState } from 'react'
import styles from './MultiSelect.module.scss'
import { clsx } from 'clsx'

export default function MultiSelect({
  options,
  selected,
  onChange,
}: {
  options: string[]
  selected?: string[]
  onChange: (selected: string[]) => void
}) {
  const [open, setOpen] = useState(false)
  const [selectedOptions, setSelectedOptions] = useState<string[]>(selected || [])
  const ref = useRef(null)

  const toggleOption = (option: string) => {
    setSelectedOptions((prev: any) =>
      prev.includes(option) ? prev.filter((o: string) => o !== option) : [...prev, option],
    )
  }

  useEffect(() => {
    const handleClickOutside = (e: any) => {
      // @ts-ignore
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    onChange(selectedOptions)
  }, [selectedOptions])

  return (
    <div className={styles['multi-select']} ref={ref} data-cy="multi-select">
      <button className={styles['multi-select-trigger']} data-cy="multi-select-trigger" onClick={() => setOpen(!open)}>
        {selectedOptions.length ? selectedOptions.join(', ') : 'Select values'}

        <span className={clsx(styles.arrow, open && styles.open)}>▼</span>
      </button>

      {open && (
        <div className={styles['multi-select-menu']} data-cy="multi-select-menu">
          {options.map((option) => (
            <label key={option} className={styles['multi-select-option']} data-cy={`multi-select-option-${option}`}>
              <input
                type="checkbox"
                checked={selectedOptions.includes(option)}
                onChange={() => toggleOption(option)}
                data-cy={`multi-select-option-${option}-input`}
              />
              <span>{option}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  )
}
